import React, { Component } from 'react';
import Breadcrumb from '../../Breadcrumb';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import CustomLoading from '../../custom/CustomLoading';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { RootState, store } from '../../../redux/store';
import { initialPagePath, PageState } from '../../../redux/reducers/PageReducer';
import { clearPage } from '../../../redux/actions/PageActions';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { WatchlistAlertDomains } from '../../../domain/watchlist/WatchlistAlertDomains';
import { WatchlistBaseModel, WatchlistIndividualRecord, WatchlistListsModel } from '../../../domain/watchlist/WatchlistDomains';
import WatchlistInformationComponent from '../watchlist/WatchlistInformationComponent';
import CustomTabv2 from '../../custom/CustomTabv2';
import WatchlistLevelModalComponent from '../detail/modal/WatchlistLevelModalComponent';
import LanguageUtil from '../../../util/LanguageUtil';
import moment from 'moment/moment';
import _ from 'lodash';
import { WatchlistType } from '../../../constant/Constants';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import NavigationUtil from '../../../util/NavigationUtil';
import eq = query.eq;

class WatchlistAlertHistoryDetailComponent extends Component<Props, State> {
  public state: State = new State();

  private computation: subscribe.Computation | undefined;
  private kycLogSubscription: subscribe.Subscription | undefined;

  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  public render() {
    const { historyItem, levelModalVisible, loading } = this.state;

    if (loading) {
      return <CustomLoading />;
    }

    if (historyItem == null) {
      return (
        <div className={'h-full w-full'}>
          <Breadcrumb />
          <div className='w-full px-5 py-5'>
            <p className='text-f-black-3'>
              {LanguageUtil.get({
                id: 'pages.alert.historyDetail.noData',
                defaultMessage: 'Veri bulunamadı. Lütfen geçmiş listesinden bir kayıt seçerek tekrar deneyin.',
              })}
            </p>
          </div>
        </div>
      );
    }

    const record = historyItem.record;
    const name = this.getName(historyItem);
    const categories = this.getCategory(historyItem);
    const recordType = record?.recordType as WatchlistType;
    const date = historyItem.timestamp == undefined ? '' : moment(historyItem.timestamp).format('DD/MM/yyyy HH:mm');

    return (
      <div className={'h-full w-full'}>
        <Breadcrumb />
        <div className='w-full px-5 py-5'>
          <div className={'flex w-full justify-between'}>
            <div className={'flex'}>
              <span
                key={'icon'}
                className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE]'
              >
                {this.getImage(historyItem, recordType)}
              </span>
              <div className={'flex flex-col justify-center pl-3'}>
                <span className={'text-[24px] 2xl:text-4xl font-normal'}>{name}</span>
                <div className={`flex items-center gap-x-2 flex-wrap`}>
                  {categories?.map((value: string, index: number) => (
                    <span
                      key={index}
                      className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center px-[8px] items-center rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                    >
                      {value}
                    </span>
                  ))}
                  <span
                    className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center items-center px-[8px] rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {date}
                  </span>
                  <span
                    className={`flex min-w-[60px] text-xs shrink-0 2xl:text-md py-1 justify-center items-center px-[8px] rounded-[50px] bg-[#DBFFEA] text-[#027A48]`}
                  >
                    {historyItem?.score ?? 0}/100
                  </span>
                  {historyItem?.level != null && (
                    <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ levelModalVisible: true })}>
                      <span className={'text-[14px] underline text-normal text-[#458EF7]'}>Level</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'flex w-full h-full'}>
          <CustomTabv2 tab={this.getTabs()} />
        </div>
        <WatchlistLevelModalComponent
          visible={levelModalVisible}
          type={recordType}
          level={historyItem?.level}
          onClose={() => this.setState({ levelModalVisible: false })}
        />
      </div>
    );
  }

  public componentDidMount = async () => {
    const { router } = this.props;
    const { location } = router;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST_ALERT];
    if (page.pagePath.length === 0 || page.pagePath[0].title !== initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST_ALERT, location.pathname, store.getState().page);
    }
    await this.getLists();
    await this.startTracker();
  };

  public componentWillUnmount = async () => {
    await this.stopTracker();
  };

  private startTracker = async () => {
    const { router } = this.props;
    const params = new URLSearchParams(router.location.search || '');
    const alertId = params.get('alertId');
    const type = params.get('type');

    if (!alertId || !type) {
      this.setState({ loading: false });
      return;
    }

    const endpoint = `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
    const kycLogQuery = query.QueryBuilder.select().where(eq('id', alertId)).from(endpoint).build();
    this.kycLogSubscription = subscribe.Formica.subscribe(endpoint, kycLogQuery, undefined, 'elasticsearch');
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.kycLogSubscription]);
  };

  private tracker = async () => {
    if (this.kycLogSubscription?.ready()) {
      await this.fetchHistoryData();
    }
  };

  private stopTracker = async () => {
    await this.kycLogSubscription?.stop();
    await this.computation?.stop();
  };

  private fetchHistoryData = async () => {
    const { router } = this.props;
    const params = new URLSearchParams(router.location.search || '');
    const alertId = params.get('alertId');
    const recordId = params.get('recordId');
    const type = params.get('type');

    if (!alertId || !recordId || !type) {
      this.setState({ loading: false });
      return;
    }
    if (!this.state.historyItem) {
        this.setState({ loading: true });
    }
    try {
      const endpoint = `kyc_${type.toLowerCase()}_log_${NavigationUtil.getTenant()}`;
      const kycLogData: WatchlistAlertDomains | undefined = await this.repository.find<WatchlistAlertDomains>(
        query.QueryBuilder.select().where(eq('id', alertId)).from(endpoint).build(),
      );
      const historyItem = kycLogData?.results?.find((result) => result.record?.id === recordId);
      
      this.setState({ historyItem, loading: false });
    } catch (e) {
      console.error(e);
      this.setState({ historyItem: undefined, loading: false });
    }
  };

  private getLists = async () => {
    try {
      const lists: WatchlistListsModel[] | undefined = await this.watchlistService.getLists();
      this.setState({ watchlistResponse: lists ?? [] });
    } catch (e) {
      console.error(e);
    }
  };

  private getTabs = () => {
    const { historyItem, watchlistResponse } = this.state;
    if (!historyItem) return [];

    const records = historyItem.record?.records ?? [];
    const recordType = historyItem.record?.recordType as WatchlistType;

    return [
      {
        key: 'Information',
        label: LanguageUtil.get({ id: 'common.tabs.information', defaultMessage: 'Information' }),
        content: <WatchlistInformationComponent selectedResponse={records} watchlistResponse={watchlistResponse} type={recordType} />,
      },
    ];
  };

  private getName = (item: WatchlistBaseModel): string => {
    const models = item?.record?.records ?? [];
    if (models.length === 0) return 'N/A';
    const watchlistRecord = models[0]?.watchlistRecord as { names?: Array<{ nameType?: string; value?: string }> };
    if (!watchlistRecord?.names?.length) return 'N/A';
    const primary = watchlistRecord.names.find((n) => n.nameType === 'PRIMARY') ?? watchlistRecord.names[0];
    return primary?.value ?? 'N/A';
  };

  private getCategory = (item: WatchlistBaseModel): string[] | undefined => {
    const records = item?.record?.records ?? [];
    if (records.length === 0) return undefined;
    const categories: string[][] = [];
    records.forEach((r) => {
      const wr = (r as { watchlistRecord?: { categories?: string[] } })?.watchlistRecord;
      if (wr?.categories) categories.push(wr.categories);
    });
    if (categories.length === 0) return undefined;
    return _.uniq(([] as string[]).concat(...categories));
  };

  private getImage = (item: WatchlistBaseModel, type: WatchlistType) => {
    const records = item?.record?.records ?? [];
    if (type === 'Individual') {
      const withImages = records.filter((r) => (r.watchlistRecord as WatchlistIndividualRecord)?.images?.length > 0);
      if (withImages.length > 0) {
        const img = (withImages[0].watchlistRecord as WatchlistIndividualRecord).images[0];
        return (
          <img
            src={img}
            alt='-'
            onClick={() => window.open(img, '_blank')}
            className='w-[60px] h-[60px] cursor-pointer border min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] object-cover'
          />
        );
      }
      return <img src={'/icons/individual.svg'} alt='individual' />;
    }
    return <img src={'/icons/entity.svg'} alt='entity' />;
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  page: state.page as PageState,
});
const mapDispatchToProps = { clearPage };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  historyItem: WatchlistBaseModel | undefined;
  watchlistResponse: WatchlistListsModel[] = [];
  levelModalVisible: boolean = false;
  loading: boolean = true;
}

export default withFormica(connector(WatchlistAlertHistoryDetailComponent));
